var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-button',{attrs:{"active":_vm.active,"action":"simulations/filter"}})}
var staticRenderFns = []

export { render, staticRenderFns }